export default __webpack_public_path__ + "static/media/background.95637f19.webp";